var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#CE2935"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5408 13.8387L55.9408 50.6387C56.2021 51.172 56.1707 51.8023 55.8576 52.307C55.5445 52.8118 54.9937 53.1199 54.3998 53.1227H17.5998C17.0058 53.1199 16.4551 52.8118 16.142 52.307C15.8289 51.8023 15.7974 51.172 16.0588 50.6387L34.4588 13.8387C34.7908 13.3072 35.3732 12.9844 35.9998 12.9844C36.6264 12.9844 37.2088 13.3072 37.5408 13.8387ZM35.9998 18.4617L20.3828 49.6727H51.6168L35.9998 18.4617ZM34.2748 28.3977H37.7248V39.8977H34.2748V28.3977ZM38.1158 43.6237C37.9993 43.3449 37.8359 43.0882 37.6328 42.8647L37.2878 42.5887L36.8738 42.3817C36.7368 42.3116 36.5891 42.265 36.4368 42.2437C35.6864 42.0934 34.9105 42.3262 34.3668 42.8647C34.1574 43.0834 33.9932 43.3413 33.8838 43.6237C33.4659 44.6366 33.8206 45.8036 34.7314 46.4127C35.6423 47.0218 36.8563 46.9038 37.6328 46.1307C37.8359 45.9071 37.9993 45.6504 38.1158 45.3717C38.3618 44.815 38.3618 44.1804 38.1158 43.6237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0f933eee800e0d27a19ff0ff5baf3c12.svg";
export { ForwardRef as ReactComponent };